// import app from '$$app';
import customDaysModel from '$$customDaysModel';

const customDayTemplates = new webix.DataCollection();

// if (!app.config.mode.isBase) {
//   customDayTemplates = new webix.DataCollection();
//
//   if (GT.ganttData.multiviewCustomDays) {
//     customDayTemplates.parse(GT.ganttData.multiviewCustomDays);
//   } else {
//     customDayTemplates.parse([{
//       ganttId: GT.ganttData.project.gantt_id,
//       user_created: 0,
//       customDays: GT.ganttData.customDays,
//     }]);
//   }
// } else {
//   customDayTemplates = new webix.DataCollection({
//     url: `rest->/api/customdaytemplates/?${new Date().getTime()}`,
//     save: {
//       url: 'rest->/api/customdaytemplates',
//       updateFromResponse: true,
//     },
//   });
// }

customDayTemplates.activeTemplateId = 0;
customDayTemplates.needRefresh = false;
customDayTemplates.userAccess = true;

customDayTemplates.getTemplateDataByGanttIdAndActive = function (ganttId) {
  let result = {};

  _.some(customDayTemplates.serialize(), templateData => {
    if (parseInt(templateData.ganttId, 10) === parseInt(ganttId, 10) && !templateData.user_create) {
      result = webix.copy(templateData);

      return true;
    }
  });

  return result;
};

customDayTemplates.getTemplateDataByTemplateId = function (templateId) {
  return webix.copy(customDayTemplates.getItem(templateId));
};

customDayTemplates.initCustomDaysByGanttId = function (ganttId) {
  const templateData = customDayTemplates.getTemplateDataByGanttIdAndActive(ganttId);

  if (templateData.id) {
    customDayTemplates.activeTemplateId = templateData.id;
    const customDays = Array.isArray(templateData.customDays) ? templateData.customDays : [templateData.customDays];

    customDaysModel.initData(customDays, templateData.id);
  } else {
    customDaysModel.initData([], null);
  }
};

customDayTemplates.initCustomDaysByTemplateId = function (templateId) {
  let templateData = {};

  if (!templateId || templateId === 'virtualTemplate') {
    templateData = {
      customDays: [],
      id: 'virtualTemplate',
    };
  } else {
    templateData = customDayTemplates.getTemplateDataByTemplateId(templateId);
    customDayTemplates.activeTemplateId = templateId;
  }

  customDaysModel.initData(templateData.customDays, templateData.id);
};

customDayTemplates.getUserTemplateList = function () {
  const result = [];

  _.each(customDayTemplates.serialize(), templateData => {
    if (templateData.user_create) {
      result.push({
        id: templateData.id,
        name: templateData.name,
        templateOwner: templateData.template_owner,
        teamShare: !!templateData.team_template,
      });
    }
  });

  return result;
};

customDayTemplates.getActiveTemplateDataByGanttId = function (ganttId) {
  const templateData = customDayTemplates.getTemplateDataByGanttIdAndActive(ganttId);

  delete templateData.customDays;

  return templateData;
};

customDayTemplates.setUserAccess = function (userAccess) {
  customDayTemplates.userAccess = userAccess;
};

customDayTemplates.getUserAccessByGanttId = function (ganttId) {
  const templateData = customDayTemplates.getActiveTemplateDataByGanttId(ganttId);
  let access = true;

  if (templateData.rights && templateData.rights < 50) {
    access = false;
  }

  return access;
};

customDayTemplates.setProjectSettingsAsUserTemplate = function (ganttId, options) {
  const projectTemplate = customDayTemplates.getActiveTemplateDataByGanttId(ganttId);

  customDayTemplates.waitForGanttId = false;
  customDayTemplates.needRefresh = options.needRefresh || false;
  customDayTemplates.add({
    type: 'userTemplateByProjectSettings',
    name: options.name,
    ganttId: null,
    projectTemplateId: projectTemplate.id,
    customDays: [],
  });
};

customDayTemplates.saveProjectSettingsAndApplyNewTemplate = function (ganttId, templateName, templateId) {
  const projectTemplate = customDayTemplates.getActiveTemplateDataByGanttId(ganttId);
  const newTemplateData = customDayTemplates.getTemplateDataByTemplateId(templateId);

  customDayTemplates.waitForGanttId = ganttId;
  customDayTemplates.add({
    type: 'copyProjectSettingsAndSetUserTemplate',
    name: templateName,
    ganttId,
    projectTemplateId: projectTemplate.id,
    userTemplateId: templateId,
    customDays: newTemplateData.customDays || [],
  });
};

customDayTemplates.workWithDataAfterSaveProjectAndUserTemplate = function (responseData) {
  customDayTemplates.data.order.push(responseData.newTemplate.id);
  customDayTemplates.data.pull[responseData.newTemplate.id] = webix.copy(responseData.newTemplate);
  customDayTemplates.data.pull[responseData.projectTemplateId].customDays = webix.copy(responseData.customDays);

  customDayTemplates.data.order.splice(customDayTemplates.data.order.indexOf(responseData.id), 1);
  delete customDayTemplates.data.pull[responseData.id];
};

customDayTemplates.clearDataAfterUpdate = function (templateId) {
  delete customDayTemplates.data.pull[templateId].type;
  delete customDayTemplates.data.pull[templateId].userTemplateId;
};

customDayTemplates.addNewCustomDay = function (customDayData, ganttId, options) {
  const templateData = customDayTemplates.getTemplateDataByGanttIdAndActive(ganttId);

  if (!templateData.id && !options.template_id) { // try create the first custom day and template didn't create
    customDayTemplates.waitCreateTemplate = true;
    customDayTemplates.waitForGanttId = ganttId;
    customDayTemplates.needRefresh = true;
    customDayTemplates.add({
      type: options.type,
      name: options.name,
      ganttId,
      customDays: customDayData,
    });
  } else {
    customDayTemplates.activeTemplateId = templateData.id || options.template_id;
    customDaysModel.addNewItem(customDayData);
  }
};

customDayTemplates.deleteUserTemplate = function (templateId) {
  customDayTemplates.needRefresh = true;
  customDayTemplates.remove(templateId);
};


customDayTemplates.updateCustomDayInTemplate = function (templateId) {
  const templateData = customDayTemplates.data.pull[templateId || customDayTemplates.activeTemplateId];

  if (templateData) {
    templateData.customDays = customDaysModel.getDaysByActiveProject();
  }
};

customDayTemplates.setAndGetCustomDaysForProject = function (ganttId) {
  customDayTemplates.initCustomDaysByGanttId(ganttId);

  return webix.copy(customDaysModel.getSortingDaysByActiveProject(ganttId));
};

customDayTemplates.addCustomDayByCollaboration = function (customDay, ganttId) {
  const projectData = customDayTemplates.getTemplateDataByGanttIdAndActive(ganttId);

  if (!projectData.id) {
    customDayTemplates.manualAddTemplateToShareProject([customDay], ganttId);
  } else if (customDayTemplates.data.pull[projectData.id]) {
    const customDays = customDayTemplates.data.pull[projectData.id].customDays;

    if (customDays.isArray) customDays.push(customDay);
  }
};

customDayTemplates.updateCustomDayByCollaboration = function (customDay, ganttId) {
  const projectData = customDayTemplates.getTemplateDataByGanttIdAndActive(ganttId);

  if (customDayTemplates.data.pull[projectData.id]) {
    let _index = -1;

    customDayTemplates.data.pull[projectData.id].customDays.forEach((el, index) => {
      if (el.id === customDay.id) {
        _index = index;
      }
    });

    if (_index >= 0) {
      customDayTemplates.data.pull[projectData.id].customDays[_index] = customDay;
    }
  }
};

export default customDayTemplates;
